<script setup>
import { ref } from 'vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: '',
  },
  alwaysOpen: {
    type: Boolean,
    default: false,
  },
  initialOpen: {
    type: Boolean,
    default: true,
  },
});

const isOpen = ref(props.alwaysOpen ? true : props.initialOpen);

const toggle = () => {
  if (props.alwaysOpen) {
    return;
  }
  isOpen.value = !isOpen.value;
};
</script>

<template>
  <div
    class="border border-n-weak rounded-lg bg-white dark:bg-slate-900 overflow-hidden mb-4"
  >
    <!-- header -->
    <button
      type="button"
      class="w-full flex items-center justify-between p-4 bg-slate-50 dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
      :class="{ 'cursor-default': alwaysOpen }"
      :aria-expanded="isOpen"
      @click="toggle"
    >
      <!-- header text -->
      <div class="flex flex-col items-start gap-1">
        <h3 class="text-sm font-medium text-n-slate-12">{{ title }}</h3>
        <p v-if="subtitle" class="text-xs text-n-slate-10">{{ subtitle }}</p>
      </div>

      <!-- header indicator -->
      <div
        v-if="!props.alwaysOpen"
        class="transform transition-transform duration-200"
        :class="{ 'rotate-180': isOpen }"
      >
        <!-- eslint-disable-next-line vue/no-bare-strings-in-template -->
        <span class="text-n-slate-10">▼</span>
      </div>
    </button>

    <!-- content -->
    <div v-show="isOpen" class="p-4 border-t border-n-weak animate-fade-in">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.animate-fade-in {
  animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
